<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img
        class="pwmat-trial-download-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-trial-download-container">
      <div class="pwmat-trial-download-content">
        <div class="pwmat-trial-download-content-title">
          <div class="pwmat-trial-download-content-title-text">
            PWmat更新方法
          </div>
          <div class="pwmat-trial-download-line"></div>
        </div>
        <div class="pwmat-trial-download-content-info">
          <p class="pwmat-trial-download-content-info-text">
            从下面选择自己平台对应的PWmat版本，按照如下步骤更新即可（这里以PWmat
            Latest CUDA8.0为例）。
          </p>
        </div>

        <div>
          <pre class="pwmat-trial-download-pre">
1. mpirun --version
------------------------------------------------------
Intel(R) MPI Library for Linux* OS, Version 2021.5 Build 20211102 (id: 9279b7d62)
注意：上述对应oneAPI 2022版本安装包

根据上面的信息下载对应版本即可

2. wget //www.pwmat.com/pwmat-resource/mstation-download/pwmat-cpu-oneAPI2022.zip


3. unzip pwmat-cpu-oneAPI2022.zip
------------------------------------------------------
Archive:  pwmat-cpu-oneAPI2022.zip
inflating: install.betaoneapi.run

4. sh install.betaoneapi.run
------------------------------------------------------
Verifying archive integrity... All good.
Uncompressing install PWmat  100%
>>> Please input the full path where to install PWmat
>>> The default directory is [/home/xxx/PWMAT]方括号内为默认的安装目录
>>> The PATH(Press Enter to accept the default):回车选择默认的目录，也可以自己手动输入
>>> The directory /home/xxx/PWMAT/xxxxxxxx ... OK!
>>> Do you wish to clean and update the .bashrc?[Y/y/N/n][default:N]y
>>> FINISH INSTALLING PWmat IN DIRECTROY: /home/xxx/PWMAT/xxxxxxxx

5. bash

6. which PWmat
------------------------------------------------------
~/PWMAT/xxxxxxxx/bin/PWmat安装成功！

         </pre
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PWmatUpdateFunc",
  data() {
    return {};
  },
  methods: {
    toPWmatUpdateFunc() {},
  },
};
</script>

<style scoped>
.pwmat-trial-download-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-trial-download-background {
  margin-top: 70px;
}
.pwmat-trial-download-banner {
  overflow: hidden;
}
.pwmat-trial-download-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-trial-download-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-trial-download-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-trial-download-content-title {
  padding-top: 50px;
}
.pwmat-trial-download-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-trial-download-content-note-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 0px;
}
.pwmat-trial-download-content-info {
  margin-top: 40px;
}
.pwmat-trial-download-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-trial-download-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}

.pwmat-trial-download-introduce-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}
.pwmat-trial-download-introduce-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}
.pwmat-trial-download-introduce-td {
  height: 45px;
}
.pwmat-trial-download-introduce-td:hover {
  background: rgba(73, 145, 201, 0.1);
}
.pwmat-trial-download-introduce-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding-left: 16px;
}
.pwmat-trial-download-introduce-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding: 16px;
}
.pwmat-trial-download-info-a {
  cursor: pointer;
}
.pwmat-trial-download-info-a:hover,
.pwmat-trial-download-info-a:active {
  text-decoration: underline;
}
.pwmat-trial-download-pre {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 32px;
}

@media screen and (max-width: 482px) {
  .pwmat-trial-download-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-trial-download-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-trial-download-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-trial-download-container {
    max-width: 1068px;
  }
}
</style>
